
export const admin_manage_user = [{
  permission: 'MANAGE_USER',
  to: '/admin/manage-user/user?sortBy=userName&orderBy=ASC&page=1&pageSize=10',
  title: 'User'
}, {
  permission: 'MANAGE_ROLE',
  to: '/admin/manage-user/role?sortBy=roleName&orderBy=ASC&page=1&pageSize=10',
  title: 'Role'
}]

export const admin_logs_and_history = [{
  permission: 'EMAIL_LOG',
  to: '/admin/log-history/email',
  title: 'Email Log History'
}, {
  permission: 'USER_ACTION_HISTORY',
  to: '/admin/log-history/user',
  title: 'User Action History'
},
{
  permission: 'SCHEDULER_LOGS',
  to: '/admin/log-history/schedularLog',
  title: "Scheduler Log History"
}]

export const admin_client_setup = [
  {
    permission: 'CLIENT_GROUP',
    to: '/admin/client-setup/client',
    title: 'Clients'
  },
  {
    permission: 'CLIENT_DETAILS',
    to: '/admin/client-setup/list?sortBy=clientId&orderBy=ASC&page=1&pageSize=10',
    title: 'Client Details'
  },
  {
    permission: 'SUB_CLIENT_DETAILS',
    to: `/admin/subclient-setup/list?sortBy=subClientId&orderBy=ASC&page=1&pageSize=10`,
    title: 'Sub-client Details'
  },
  {
    permission: 'SETUP_DETAILS',
    to: '/admin/subclient-setup/setup-details',
    title: 'Sub-client Setup Details'
  },
  {
    permission: 'SCHEDULER_DETAILS',
    to: '/admin/schedular-details',
    title: 'Scheduler Details'
  },
  {
    permission: 'EMAIL_RECEIPIENTS',
    to: '/admin/client-setup/email-recipients',
    title: 'Email Recipients'
  },
  {
    permission: 'BILLING_GROUPS',
    to: '/admin/client-setup/billing-groups',
    title: 'Billing Groups'
  },
  {
    permission: 'CUSTOMER_GROUPS',
    to: '/admin/client-setup/customer-groups',
    title: 'Customer Groups'
  },
]
